/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountFeatureDetails {
    getFixupPrototypeFunction() { return ServiceAccountFeatureDetails.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountFeatureDetails>): ServiceAccountFeatureDetails {
        let obj = Object.assign(new ServiceAccountFeatureDetails(), model);
        ServiceAccountFeatureDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountFeatureDetails>): ServiceAccountFeatureDetails {
        if (!model) return null;
        return ServiceAccountFeatureDetails.newInstance(<ServiceAccountFeatureDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountFeatureDetails) {
        if (!obj) return;

        models.ServiceAccountFeatureDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountFeatureDetails): boolean {
        Object.setPrototypeOf(obj, ServiceAccountFeatureDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.onboarded_at === "string") {
            this.onboarded_at = new Date(<string><any>this.onboarded_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.background_job_id) {
            models.RecordIdentity.fixupPrototype(this.background_job_id);
        }
    }

    /**
     * Feature for the account
     */
    feature: models.ServiceAccountFeature;

    /**
     * Status of an account feature
     */
    status: models.ServiceAccountFeatureStatus;

    /**
     * If set, feature is temporarily inactive
     */
    inactive: boolean;

    /**
     * If set, feature failures will not raise a warning in the UI
     */
    silence: boolean;

    /**
     * The desired status of the service account
     */
    desired_status: models.ServiceAccountFeatureStatus;

    /**
     * Failure reason
     */
    failure_reason: string;

    /**
     * Optional tool account linked to this feature.
     */
    tool_account_id: string;

    /**
     * Onboarding timestamp
     */
    onboarded_at: Date;

    /**
     * Name of the user who onboarded the feature.
     */
    onboarded_by: string;

    /**
     * Last update timestamp
     */
    updated_at: Date;

    /**
     * Background Job Id for onboarding/offboarding
     */
    background_job_id: models.RecordIdentity;

}
